import React from 'react';

import './aquarium-loading-screen.css';

function LoadingFish({ className = '' }: { className?: string }) {
  return <svg className={`aquarium-loading-fish ${className}`.trim()} viewBox="0 0 100 64" fill="none" aria-hidden="true">
    <path d="M23 32c10-14 29-22 51-17l13 9v16l-13 9c-22 5-41-3-51-17Z" fill="currentColor" />
    <path d="m25 32-21-18c4 12 4 24 0 36l21-18Z" fill="currentColor" opacity=".76" />
    <path d="M50 17c6 4 10 9 11 15 1 6-2 12-8 16M61 16c5 5 8 10 8 16s-3 11-8 16" stroke="#fff8df" strokeWidth="2" strokeLinecap="round" opacity=".72" />
    <circle cx="77" cy="27" r="5" fill="#fff8df" />
    <circle cx="78" cy="27" r="2.3" fill="#153b4a" />
  </svg>;
}

const BUBBLES = [8, 17, 26, 38, 52, 63, 74, 83, 92];

export function AquariumLoadingScreen() {
  return <main className="aquarium-loading-screen" role="status" aria-live="polite">
    <div className="aquarium-loading-rays" aria-hidden="true"><span /><span /><span /></div>
    <div className="aquarium-loading-bubbles" aria-hidden="true">
      {BUBBLES.map((left, index) => <span key={left} style={{ left: `${left}%`, animationDelay: `${-index * 1.7}s`, animationDuration: `${9 + (index % 4) * 2}s`, width: 6 + (index % 3) * 5, height: 6 + (index % 3) * 5 }} />)}
    </div>
    <LoadingFish className="aquarium-loading-fish--far aquarium-loading-fish--far-one" />
    <LoadingFish className="aquarium-loading-fish--far aquarium-loading-fish--far-two" />

    <div className="aquarium-loading-content">
      <div className="aquarium-loading-orb" aria-hidden="true">
        <div className="aquarium-loading-orb__water">
          <span className="aquarium-loading-orb__wave aquarium-loading-orb__wave--back" />
          <span className="aquarium-loading-orb__wave aquarium-loading-orb__wave--front" />
        </div>
        <LoadingFish className="aquarium-loading-orb__fish" />
        <span className="aquarium-loading-orb__shine" />
      </div>
      <h1>Загружаем аквариум</h1>
      <p className="aquarium-loading-copy">Рыбки уже плывут к экрану</p>
      <div className="aquarium-loading-dots" aria-hidden="true"><span /><span /><span /></div>
    </div>
    <div className="aquarium-loading-floor" aria-hidden="true" />
  </main>;
}
